import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  description: string,
 *  groupName: string,
 *  id: number,
 *  indicatorType: string,
 *  indicatorUnitTypeId: number,
 *  indicatorValues: Array,
 *  isBeforeAfter: boolean,
 *  tooltipText: string }} Indicators
 */

/**
 * @typedef {{
 *  categoryId: number,
 *  categoryNameText: string,
 *  indicators: Indicators[] }} Outputs
 */

/**
 * @typedef {{
 *  categoryId: number,
 *  categoryNameText: string,
 *  indicators: Indicators[] }} Outcomes
 */

/**
 * @typedef {{
 *  outputs: Outputs[],
 *  outcomes: Outcomes[] }} ProjectResultIndicators
 */

const api = new Api("api/Projects");

/**
 * @param projectId
 * @returns {Promise<AxiosResponse<ProjectResultIndicators[]>>}
 */
export const getProjectResultIndicators = (projectId) =>
  api.get(`/${projectId}/results/indicators`);

export const saveBrandNewProjectResults = (projectId, payload) =>
  api.post(`/${projectId}/results`, payload);

export const updateProjectResults = (projectId, payload) =>
  api.put(`/${projectId}/results`, payload);
